import React from "react";
import { Box } from "@mui/material";
import SidebarMenu from "./CreateNewCustomerSidebarMenu";

export default function CreateJobLayout({
  activeIndex,
  setActiveIndex,
  children,
  
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column", // 🔹 top → bottom layout
        width: "100%",
        height: "100vh", // full height
        overflow: "hidden",
      }}
    >
      <SidebarMenu activeIndex={activeIndex} setActiveIndex={setActiveIndex} />

      {/* === Main Content (Below Header) === */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          backgroundColor: "var(--gray-0)",
          // borderTop: "1px solid var(--gray-100)",
          padding: 2,

          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "var(--gray-400)",
            borderRadius: "8px",
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
